import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router";
import { useTranslation } from "react-i18next";
import { ArrowLeftIcon, ArrowRightIcon } from "@heroicons/react/24/outline";

import { useGallery } from "../../hooks/useGallery";
import { useGalleryStore } from "../../store/galleryStore";
import Loading from "../../components/atoms/Loading";
import Post from "../../components/organisms/gallery/Post";

function GalleryPost() {
  const { t } = useTranslation(["gallery"]);
  const params = useParams();
  const { retrievePost } = useGallery();
  const post = useGalleryStore((state) => state.post);
  const setPost = useGalleryStore((state) => state.setPost);

  useEffect(() => {
    retrievePost(params.exchangeSafe, params.titleSafe);
  }, [params.exchangeSafe, params.titleSafe]);

  useEffect(() => {
    return () => {
      setPost(null);
    };
  }, []);

  return (
    <>
      <title>
        {post ? `${post.title} - Givin Gifts` : "Gallery Post - Givin Gifts"}
      </title>
      <div className="bg-surface-base">
        <main id="main-content">
          {post && (
            <div className="bg-surface-raised">
              <div className="py-3 px-3 lg:px-0 lg:py-5 lg:container lg:mx-auto max-3xl max-md:mt-[70px] flex flex-row justify-between items-center">
                <div>
                  <Link
                    to={
                      post.prevPost
                        ? `/gallery/${post.prevPost.exchangeSafe}/${post.prevPost.titleSafe}`
                        : "#"
                    }
                    className={`font-bold text-text-base flex flex-row items-center uppercase gap-3 ${
                      !post.prevPost ? "opacity-50 cursor-not-allowed" : ""
                    }`}
                  >
                    <span>
                      <ArrowLeftIcon className="w-4 h-4" />
                    </span>
                    <span>
                      <span className="sr-only sm:!not-sr-only">Previous </span>
                      <span className="sr-only md:!not-sr-only">post</span>
                    </span>
                  </Link>
                </div>
                <h1 className="text-xl font-bold text-text-primary">{post.title}</h1>
                <div>
                  <Link
                    to={
                      post.nextPost
                        ? `/gallery/${post.nextPost.exchangeSafe}/${post.nextPost.titleSafe}`
                        : "#"
                    }
                    className={`font-bold text-text-base flex flex-row items-center uppercase gap-3 ${
                      !post.nextPost ? "opacity-50 cursor-not-allowed" : ""
                    }`}
                  >
                    <span>
                      <ArrowRightIcon className="w-4 h-4" />
                    </span>
                    <span>
                      <span className="sr-only sm:!not-sr-only">Next </span>
                      <span className="sr-only md:!not-sr-only">post</span>
                    </span>
                  </Link>
                </div>
              </div>
            </div>
          )}
          <div className="py-3 px-3 lg:px-0 lg:py-5 lg:container lg:mx-auto max-3xl">
            {!post ? <Loading /> : <Post post={post} />}
          </div>
        </main>
      </div>
    </>
  );
}

export default GalleryPost;
